/**
 * @ngdoc module
 * @name evtviewer.search
 * @module evtviewer.search
 * @description ...
**/
angular.module('evtviewer.search', []);